import { useSearchParams } from 'react-router-dom';
import { useAuth } from '../store/auth.ts';
import { DashboardTab } from '../components/admin/DashboardTab.tsx';
import { UsersTab } from '../components/admin/UsersTab.tsx';
import { JobsTab } from '../components/admin/JobsTab.tsx';
import { SettingsTab } from '../components/admin/SettingsTab.tsx';
import { ReleasesTab } from '../components/admin/ReleasesTab.tsx';
import { AuditTab } from '../components/admin/AuditTab.tsx';
import { EmptyState } from '../components/common/EmptyState.tsx';

const TABS = [
  { key: 'dashboard', label: '대시보드' },
  { key: 'users', label: '사용자' },
  { key: 'jobs', label: '백그라운드 잡' },
  { key: 'settings', label: '운영 정책' },
  { key: 'releases', label: '클라이언트 배포' },
  { key: 'audit', label: '감사 로그' },
] as const;

type TabKey = (typeof TABS)[number]['key'];

export function AdminPage() {
  const role = useAuth((s) => s.user?.role);
  const [params, setParams] = useSearchParams();
  const raw = params.get('tab') ?? 'dashboard';
  const tab: TabKey = TABS.some((t) => t.key === raw) ? (raw as TabKey) : 'dashboard';

  // 서버도 관리자만 통과시키지만, 화면에서도 막아 잘못된 요청 자체를 줄인다
  if (role !== 'admin') {
    return (
      <div className="page">
        <EmptyState title="접근 권한이 없습니다" description="관리자만 사용할 수 있는 화면입니다." />
      </div>
    );
  }

  return (
    <div className="page">
      <div className="page__head">
        <h1 className="page__title">관리</h1>
        <div className="drawer__tabs" style={{ padding: 0, flexWrap: 'wrap' }} role="tablist">
          {TABS.map((t) => (
            <button
              key={t.key}
              className="drawer__tab"
              data-active={tab === t.key}
              role="tab"
              aria-selected={tab === t.key}
              onClick={() => { setParams({ tab: t.key }); }}
            >
              {t.label}
            </button>
          ))}
        </div>
      </div>

      <div className="page__body" style={{ padding: 'var(--sp-4)' }}>
        {tab === 'dashboard' && <DashboardTab />}
        {tab === 'users' && <UsersTab />}
        {tab === 'jobs' && <JobsTab />}
        {tab === 'settings' && <SettingsTab />}
        {tab === 'releases' && <ReleasesTab />}
        {tab === 'audit' && <AuditTab />}
      </div>
    </div>
  );
}
